import { Token } from '@coast/schemas';
import { first, isNil } from 'lodash';
import { useContext } from 'react';
import { MBView } from '@shared/components/MBView';
import { MBIconV2Name } from '@shared/components/image';
import { PressableTextRow } from '@shared/components/list';
import { WorkflowTemplateDataContext } from '@shared/scenes/workflows/context/WorkflowTemplateDataProvider';
import { cursorPointerStyle } from '@shared/styles';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';

type Component = API.PersonComponentFragment;

interface Props {
  component: Component;
}

export function DefaultPersonRow({ component }: Props) {
  const { users } = useContext(WorkflowTemplateDataContext);
  const cardText = getCardText(component, users);

  return (
    <MBView style={cursorPointerStyle}>
      <PressableTextRow
        text={cardText}
        leftIcon={component.icon as MBIconV2Name}
        rightIcon="arrow-point-right"
        enabled={true}
        onPress={undefined}
      />
    </MBView>
  );
}

function getCardText(component: Component, users: API.ShortUserFragment[]) {
  const userIds = component.default?.userIds ?? [];
  if (component.default?.token === Token.ME) {
    const additionalRowText =
      userIds.length > 0 ? i18n('builder.defaultPerson.rowText', { count: userIds.length }) : '';
    return i18n('builder.defaultPerson.meSelection') + additionalRowText;
  }

  const firstUserId = first(userIds);
  const firstUser = users.find(user => {
    return user.id === firstUserId;
  });
  if (isNil(firstUser)) {
    return '';
  }
  const additionalRowText =
    userIds.length > 1 ? i18n('builder.defaultPerson.rowText', { count: userIds.length - 1 }) : '';

  return firstUser.fullName + additionalRowText;
}
